// These colors are also defined in App.scss to be used in *.scss files. From here, they can be imported into *.tsx files
export const bqaLightBlue = "#add3e8";
export const bqaBlue = "#1c00ff";
export const bqaDarkBlue = "#0f0570";
export const bqaDarkGrey = "#333333";

export const paleYellow = "#FFFFD4";
export const darkYellow = "#2F2F00";
